import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, delay, Observable, of, tap } from 'rxjs';
import ApiOptionsConfig from './api-options.config';
import { CompanyLocationsService } from './general-settings/company-locations.service';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { StoreService } from '../store.service';
import { environment } from '../../../environments/environment';

export interface WelcomeLetter {
  subject: {
    eng: string;
    ita: string;
    spa: string;
  };
  content: {
    eng: string;
    ita: string;
    spa: string;
  };
}


const BASE_URL = '/customers';
const BASE_URL_SETTINGS_CLIENTS_TYPE = '/customer-types';
const BASE_URL_SETTINGS_MESSAGES = '/customer-welcome-letters';
const BASE_URL_CLIENTS_PERSONS = '/customer-persons';
const BASE_URL_DOCUMENTS = '/customer-documents';
const BASE_URL_WELCOME_LETTER = '/welcome-letters';
@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  accessToken: string = '';

  storeService: StoreService;
  httpClient: HttpClient;


  private customers = [
    {
      id: '2',
      code: "C001",
      rnk: "12",
      isClient: true,
      companyName: "MNG Entertainment Srl",
      city: "Milano",
      country: "Italy",
      phone: "+39 02 12345678",
      email: "pavel.n@mascot.games",
      surname: "Rossi",
      customerType: 'Tribal',
      address: 'Via G. Verdi 25',
      zipCode: '20124',
      vat: '',
      tax: '0987654',
      vat_tax: 'Tax',
      clientLanguage: 'ita',
      introducer: 'Juan Daruich',
      directorName: 'Giacomo',
      directorDocument: 'Bruni',
      residing: 'edge',
      contacts: [
        {
          administrations: [
            {
              name: 'Claudio',
              surname: 'Boffa',
              email: 'claudio.boffa@example.com',
              phone: '+39 123 456 7890',
              teams: 'claudio.boffa'
            }
          ],
          companyOwner: [
            {
              name: 'Marco',
              surname: 'Rossi',
              email: 'marco.rossi@example.com',
              phone: '+39 987 654 3210',
              teams: 'marco.rossi'
            }
          ],
          other: [],
          projectManager: [],
          technicalResponsible: [
            {
              name: 'Luca',
              surname: 'Verdi',
              email: 'luca.verdi@example.com',
              phone: '+39 321 654 9870',
              teams: 'luca.verdi'
            }
          ]
        }],
      notes: [
        {
          content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
          author: "Mario Rossi",
          timestamp: "17/02/2025, 11:09:49"
        },
        {
          content: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
          author: "Luca Bianchi",
          timestamp: "17/02/2025, 12:30:15"
        }],
      files: [
        {
          id: 3,
          name: 'Manuale Utente.pdf',
          url: 'assets/pdfs/manuale-utente.pdf',
          size: '3.2 MB'
        }, {
          id: 2,
          name: 'Analisi Tecnica.pdf',
          url: 'assets/pdfs/analisi-tecnica.pdf',
          size: '1.8 MB'
        },]

    },
    {
      id: '3',
      code: "C002",
      rnk: "5",
      isClient: false,
      companyName: "Loteria de la Ciudad de Buenos Aires S.E.",
      city: "Roma",
      country: "Italy",
      phone: "+39 06 87654321",
      email: "saverio@galois.srl",
      surname: "Bianchi",
      customerType: 'Operator',
      address: 'Via F. Rossi 47',
      zipCode: '00184',
      vat: '6543210',
      tax: '',
      vat_tax: 'Vat',
      clientLanguage: 'eng',
      introducer: 'Vladimir Petrov',
      directorName: 'Aldo',
      directorDocument: 'Deiola',
      residing: 'dejb',
      contacts: [
        {
          administrations: [{
            name: 'Marco',
            surname: 'Rossi',
            email: 'marco.rossi@example.com',
            phone: '+39 987 654 3210',
            teams: 'marco.rossi'
          }],
          companyOwner: [],
          other: [],
          projectManager: [{
            name: 'Luca',
            surname: 'Verdi',
            email: 'luca.verdi@example.com',
            phone: '+39 321 654 9870',
            teams: 'luca.verdi'
          },
          {
            name: 'Claudio',
            surname: 'Boffa',
            email: 'claudio.boffa@example.com',
            phone: '+39 123 456 7890',
            teams: 'claudio.boffa'
          }],
          technicalResponsible: []
        }
      ],
      notes: [
        {
          content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
          author: "Giuseppe Verdi",
          timestamp: "28/01/2025, 16:32:17"
        }],
      files: [
        {
          id: 1,
          name: 'Progetto Strutturale.pdf',
          url: 'assets/pdfs/progetto-strutturale.pdf',
          size: '2.3 MB'
        },

        {
          id: 4,
          name: 'Specifiche di Costruzione.pdf',
          url: 'assets/pdfs/specifiche-costruzione.pdf',
          size: '2.1 MB'
        }
      ]
    }
  ]

  private customerSettings = {
    welcomeLetter: {
      subject: {
        eng: 'The Random Number Generator shall meet at least the following requirements:   The randomly generated data shall be statistically independent.',
        ita: 'Il generatore di numeri casuali deve soddisfare almeno i seguenti requisiti:   I dati casuali generati devono essere statisticamente indipendenti.',
        spa: 'El Generador de Números Aleatorios deberá cumplir, como mínimo, los siguientes requisitos: ● Los datos aleatorios generados deben ser estadísticamente independientes.',
      },
      content: {
        eng: 'The Random Number Generator shall meet at least the following requirements:   The randomly generated data shall be statistically independent.',
        ita: 'Il generatore di numeri casuali deve soddisfare almeno i seguenti requisiti:   I dati casuali generati devono essere statisticamente indipendenti.',
        spa: 'El Generador de Números Aleatorios deberá cumplir, como mínimo, los siguientes requisitos: ● Los datos aleatorios generados deben ser estadísticamente independientes.',
      }
    },
    clientTypes: [
      {
        clientTypeId: '1',
        name: 'Game Provider',
        code: 'game_provider',
        createTime: '2023-10-01T12:00:00Z',
      },
      {
        clientTypeId: '2',
        name: 'Tribal',
        code: 'Tribal',
        createTime: '2024-08-16T19:50:00Z',
      }
    ],
    documents: {
      standard: [
        {
          language: 'eng',
          documentName: 'Document 1',
          fileName: 'document1.pdf',
          url: 'assets/pdfs/deocument1.pdf',
          size: '3.2 MB'
        },
        {
          language: 'ita',
          documentName: 'Document 3',
          fileName: 'document3.pdf',
          url: 'assets/pdfs/document3.pdf',
          size: '2.6 MB'
        }
      ],
      extra: [
        {
          language: 'ita',
          documentName: 'Document 3',
          fileName: 'document3.pdf',
          url: 'assets/pdfs/document3.pdf',
          size: '2.6 MB'
        }
      ]
    }
  }
  private countriesSubject = new BehaviorSubject<string[]>([]);
  public countries$ = this.countriesSubject.asObservable();

  constructor(private countriesService: CompanyLocationsService) {
    this.countriesService.list().subscribe({
      next: (response: any) => {
        const updatedCountries = response.data.companyLocations.map((country: any) => country.name);
        this.countriesSubject.next(updatedCountries);
      },
      error: (error: any) => {
        console.error('Error fetching countries:', error);
      }
    });

    this.storeService = inject(StoreService);
    this.httpClient = inject(HttpClient);

    this.storeService.getAuthToken().subscribe(
      (data: any) => { this.accessToken = data ? data['accessToken'] : null }
    )
  }







  GET(url: string, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    }
    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.get<any>(url, {
      headers,
      params
    });
  }

  POST(url: string, data: any, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    }
    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.post<any>(url, data, {
      headers,
      params
    });
  }


  POSTMULTIPART(url: string, formData: FormData, params?: HttpParams): Observable<any> {
    let headers = new HttpHeaders();
    if (formData instanceof FormData) {
      if (this.accessToken) {
        headers = headers.set('Authorization', `Bearer ${this.accessToken}`);
      }
      console.log('POSTMULTIPART', 'formData', formData, 'url', url, 'params', params);

      return this.httpClient.post<any>(url, formData, {
        headers,
        params,
      });
    }

    return of({ error: 'Invalid FormData object provided' });
  }

  POSTMULTIPARTFILE(url: string, formData: FormData, params?: HttpParams): Observable<HttpResponse<Blob>> {
    let headers = new HttpHeaders();
    if (this.accessToken) {
      headers = headers.set('Authorization', `Bearer ${this.accessToken}`);
    }

    return this.httpClient.post(url, formData, {
      headers,
      params,
      observe: 'response',
      responseType: 'blob'
    });
  }

  PUT(url: string, data: any, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    };

    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.put<any>(url, data, {
      headers,
      params
    });
  }

  DELETE(url: string, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    }
    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.delete<any>(url, {
      headers,
      params
    });
  }

  getUrl(path: string): string {
    return `${environment.apiBaseUrl}${path}`
  }




  list(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL), options?.params);
  }

  detail(customerId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${customerId}`), options?.params);
  }

  create(data: any): Observable<any> {
    return this.POST(this.getUrl(BASE_URL), data);
  }

  update(customerId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${customerId}`), data);
  }

  delete(customerId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${customerId}`));
  }

  me(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/me`), options?.params);
  }

  listDocumentsForClient(customerId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${customerId}/documents`), options?.params);
  }

  listExtraDocumentsForClient(customerId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${customerId}/documents-extra`), options?.params);
  }

  sendDocuments(customerId: number, documentId: number, formData: FormData): Observable<any> {
    return this.POSTMULTIPART(this.getUrl(`${BASE_URL}/${customerId}/documents/${documentId}/upload-customer-attachment`), formData);
  }

  addExtraDocuments(customerId: number, extraDocumentId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${customerId}/documents/${extraDocumentId}`), data);
  }

  statusDocuments(customerId: number, documentId: number, nextStatus: string, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${customerId}/documents/${documentId}/change-status/${nextStatus}`), data);
  }

  listOtherAgreements(customerId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${customerId}/other-agreements`), options?.params);
  }

  createOtherAgreements(customerId: number, formData: FormData): Observable<any> {
    return this.POSTMULTIPART(this.getUrl(`${BASE_URL}/${customerId}/other-agreements`), formData);
  }

  deleteOtherAgreements(customerId: number, agreementId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${customerId}/other-agreements/${agreementId}`));
  }

  listOtheDocuments(customerId: number , options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${customerId}/other-documents`), options?.params);
  }

  createOtherDocuments(customerId: number, formData: FormData): Observable<any> {
    return this.POSTMULTIPART(this.getUrl(`${BASE_URL}/${customerId}/other-documents`), formData);
  }
  
  deleteOtherDocuments(customerId: number, agreementId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${customerId}/other-documents/${agreementId}`));
  }




  listSettingsClientsTypes(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL_SETTINGS_CLIENTS_TYPE), options?.params);
  }

  detailSettingsClientsTypes(clientTypeId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL_SETTINGS_CLIENTS_TYPE}/${clientTypeId}`), options?.params);
  }

  createSettingsClientsTypes(data: any): Observable<any> {
    return this.POST(this.getUrl(BASE_URL_SETTINGS_CLIENTS_TYPE), data);
  }

  updateSettingsClientsTypes(clientTypeId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL_SETTINGS_CLIENTS_TYPE}/${clientTypeId}`), data);
  }

  deleteSettingsClientsTypes(clientTypeId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL_SETTINGS_CLIENTS_TYPE}/${clientTypeId}`));
  }



  listSettingsMessages(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL_SETTINGS_MESSAGES), options?.params);
  }

  detailSettingsMessages(clientWelcomeLetterId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL_SETTINGS_MESSAGES}/${clientWelcomeLetterId}`), options?.params);
  }

  createSettingsMessages(data: any): Observable<any> {
    return this.POST(this.getUrl(BASE_URL_SETTINGS_MESSAGES), data);
  }

  updateSettingsMessages(clientWelcomeLetterId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL_SETTINGS_MESSAGES}/${clientWelcomeLetterId}`), data);
  }

  deleteSettingsMessages(clientWelcomeLetterId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL_SETTINGS_MESSAGES}/${clientWelcomeLetterId}`));
  }

  updateAccountSendCredentialToEmail(customerId: number, customerPersonId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${customerId}${BASE_URL_CLIENTS_PERSONS}/${customerPersonId}/create-user`), data);
  }


  listClientPersons(clientsId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${clientsId}/customer-persons`), options?.params);
  }

  detailClientPersons(customerId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${customerId}`), options?.params);
  }

  createClientPersons(clientsId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${clientsId}/customer-persons`), data);
  }

  updateClientPersons(clientsId: number, clientsPersonId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${clientsId}/customer-persons/${clientsPersonId}`), data);
  }

  deleteClientPersons(clientsId: number, clientsPersonId: number,): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${clientsId}/customer-persons/${clientsPersonId}`));
  }


  listDocuments(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL_DOCUMENTS}`), options?.params);
  }

  detailDocuments(documentId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL_DOCUMENTS}/${documentId}`), options?.params);
  }

  createDocuments(formData: FormData): Observable<any> {
    return this.POSTMULTIPART(this.getUrl(`${BASE_URL_DOCUMENTS}`), formData);
  }

  updateDocuments(documentId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL_DOCUMENTS}/${documentId}`), data);
  }

  deleteDocuments(documentId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL_DOCUMENTS}/${documentId}`));
  }

  sendReminderToClient(customerId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${customerId}/documents/send-reminder`), data);
  }

  listWelcomeLetters(clientsId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${clientsId}${BASE_URL_WELCOME_LETTER}`), options?.params);
  }
  createWelcomeLetters(clientsId: number, welcomeLetterId: number,data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${clientsId}${BASE_URL_WELCOME_LETTER}/${welcomeLetterId}/send`),data);
  }

  createFileNDA(clientsId: number, formData: FormData): Observable<HttpResponse<Blob>> {
    return this.POSTMULTIPARTFILE(this.getUrl(`${BASE_URL}/${clientsId}/generate-nda`), formData);
  }





  listSettings(options?: ApiOptionsConfig): Observable<any> {
    const response = {
      status: {
        code: 200,
        description: "OK",
        timestamp: new Date().toISOString(),
        trace: "67ab61fa86fa199e4b87104e49f9e3a0",
        span: "9c9192726658a369"
      },
      data: {
        customerSettings: this.customerSettings
      },
      pagination: {
        page: 0,
        pageSize: 25,
        pageItemCount: 2,
        totalCount: 2,
        totalPages: 1
      }
    };
    return of(response).pipe(delay(500));
  }

  detailSettingsClientType(id: string): Observable<any> {
    let clientType = this.customerSettings.clientTypes.find(c => c?.clientTypeId == id);

    if (clientType) {
      return of({
        status: {
          code: 200,
          description: "OK",
          timestamp: new Date().toISOString()
        },
        data: { clientTypes: clientType }
      }).pipe(delay(500));
    } else {
      return of({
        status: {
          code: 404,
          description: "Client Type Not Found",
          timestamp: new Date().toISOString()
        }
      }).pipe(delay(500));
    }
  }
  createSettingsClientType(clientType: any): Observable<any> {
    this.customerSettings.clientTypes.push(clientType);
    return of({
      status: {
        code: 201,
        description: "Proposal Created",
        timestamp: new Date().toISOString()
      },
      data: {
        clientTypes: clientType
      }
    }).pipe(delay(500));
  }

  updateSettingsClientType(id: string, updatedClientType: { clientTypeId: string, name: string, code: string, createTime: string }): Observable<any> {
    let clientType = this.customerSettings.clientTypes.find(c => c.clientTypeId === id);

    if (clientType) {
      Object.assign(clientType, updatedClientType);
      return of({
        status: {
          code: 200,
          description: "Proposal Updated",
          timestamp: new Date().toISOString()
        },
        data: {
          clientTypes: clientType
        }
      }).pipe(delay(500));
    } else {
      return of({
        status: {
          code: 404,
          description: "Proposal Not Found",
          timestamp: new Date().toISOString()
        }
      }).pipe(delay(500));
    }
  }



  listNotes(customerId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${customerId}/notes`), options?.params);
  }

  createNotes(customerId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${customerId}/notes`), data);
  }

  deleteNotes(customerId: number, sectionNoteId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${customerId}/notes/${sectionNoteId}`));
  }
}
